var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _circle, _circle2, _circle3, _path9, _g3, _rect2, _path10, _path11, _path12, _path13, _path14, _path15, _g4, _path16, _path17, _path18, _path19, _path20, _path21, _g5, _path22, _g6, _g7, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 170,
    viewBox: "0 0 324 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_93997)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 324,
    height: 170,
    rx: 12.0343,
    fill: "url(#paint0_linear_374_93997)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 170H296.229L129.9 -33.6571H0V170Z",
    fill: "url(#paint1_linear_374_93997)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M366.194 22.8693C386.615 51.0994 373.736 93.9297 337.753 119.959C301.868 145.918 258.296 143.595 237.819 115.288C217.236 86.8345 227.223 41.2759 262.929 15.4462C298.637 -10.3845 345.611 -5.58343 366.194 22.8693Z",
    stroke: "url(#paint2_linear_374_93997)",
    strokeWidth: 6.46129
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360.2 8.20731C389.995 43.5164 382.299 86.2103 340.851 119.849C298.174 151.317 251.879 143.725 227.546 112.775C203.213 81.8245 212.137 30.3766 249.927 3.03997C287.716 -24.2966 337.782 -22.7825 360.2 8.20731Z",
    fill: "url(#paint3_linear_374_93997)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.843 7.38685C366.08 21.5373 367.773 39.3402 362.241 57.1117C356.7 74.9071 343.934 92.5181 325.555 105.813C288.59 132.553 244.247 130.701 223.811 102.451C203.271 74.0575 213.96 27.9001 250.745 1.29011C287.531 -25.3209 335.304 -21.006 355.843 7.38685Z",
    stroke: "#A6751B",
    strokeWidth: 6.46129
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347.59 7.43111C364.519 30.8338 355.012 71.1141 319.573 96.751C284.133 122.388 242.9 118.812 225.971 95.4093C209.042 72.0067 218.549 31.7263 253.989 6.08948C289.428 -19.5474 330.661 -15.9716 347.59 7.43111Z",
    fill: "url(#paint4_linear_374_93997)",
    stroke: "url(#paint5_linear_374_93997)",
    strokeWidth: 17.948
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.107 87.8013L254.601 60.5609L317.655 68.3994L291.107 87.8013Z",
    fill: "#A97B24",
    stroke: "#CAA65F",
    strokeWidth: 0.925714
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.197 60.1007L301.212 33.931L290.531 86.8053L254.197 60.1007Z",
    fill: "#A97B24",
    stroke: "#CAA65F",
    strokeWidth: 0.925714
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_374_93997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.2764C280.062 44.8668 283.01 42.5277 296.218 36.2602C290.252 40.477 280.469 45.9851 276.653 47.2764Z",
    fill: "#A97B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.2764C280.062 44.8668 283.01 42.5277 296.218 36.2602C290.252 40.477 280.469 45.9851 276.653 47.2764Z",
    stroke: "#CAA65F",
    strokeWidth: 0.925714
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_374_93997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.257 83.5019C273.272 73.0556 269.453 60.4177 272.321 49.8276C282.341 55.1435 287.675 77.7253 285.257 83.5019Z",
    fill: "#A97B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.257 83.5019C273.272 73.0556 269.453 60.4177 272.321 49.8276C282.341 55.1435 287.675 77.7253 285.257 83.5019Z",
    stroke: "#CAA65F",
    strokeWidth: 0.925714
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.341 60.0459L284.724 83.1109L263.932 28.916L253.341 60.0459Z",
    fill: "#A97B24",
    stroke: "#CAA65F",
    strokeWidth: 0.925714
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.403,
    cy: 33.1059,
    r: 4.05936,
    transform: "rotate(36.3143 301.403 33.1059)",
    fill: "#A97B24",
    stroke: "#CAA65F",
    strokeWidth: 0.462857
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.193,
    cy: 68.4702,
    r: 3.39924,
    transform: "rotate(36.3143 317.193 68.4702)",
    fill: "#A97B24",
    stroke: "#CAA65F",
    strokeWidth: 0.462857
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.15,
    cy: 29.4861,
    r: 3.39924,
    transform: "rotate(-8.68571 264.15 29.4861)",
    fill: "#A97B24",
    stroke: "#CAA65F",
    strokeWidth: 0.462857
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M338.91 13.7393C346.197 23.8137 347.156 37.1811 342.578 50.787C338.001 64.3897 327.915 78.1064 313.354 88.6404C298.792 99.1744 282.608 104.461 268.256 104.551C253.901 104.642 241.505 99.5475 234.217 89.4731C226.929 79.3987 225.97 66.0314 230.549 52.4254C235.126 38.8228 245.211 25.1061 259.773 14.5721C274.335 4.03811 290.519 -1.24831 304.871 -1.33869C319.226 -1.42908 331.622 3.66493 338.91 13.7393Z",
    stroke: "url(#paint6_linear_374_93997)",
    strokeWidth: 2.87168
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_374_93997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.786 47.0591L378.34 63.878C381.61 44.6601 374.46 29.2783 371.65 25.0111C369.426 20.8425 365.3 14.9871 360.441 8.56229C347.545 -11.5991 320.361 -29.5809 278.102 -16.1535C227.842 1.13154 211.183 41.863 209.396 59.8486L363.49 45.0899L367.786 47.0591Z",
    fill: "#FEFFFE",
    fillOpacity: 0.22
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dddddd_374_93997)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_93997)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 46.9883,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "url(#paint7_linear_374_93997)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddddd_374_93997)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 57.9422L29.777 51.9912L27.7933 57.9422H25.1484Z",
    fill: "url(#paint8_linear_374_93997)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7939 57.9422L29.7776 51.9912L31.7613 57.9422H27.7939Z",
    fill: "url(#paint9_linear_374_93997)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7773 51.9912L31.761 57.9422H34.4059L29.7773 51.9912Z",
    fill: "url(#paint10_linear_374_93997)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 63.8934L25.1484 57.9424H27.7933L29.777 63.8934Z",
    fill: "url(#paint11_linear_374_93997)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7613 57.9424H27.7939L29.7776 63.8934L31.7613 57.9424Z",
    fill: "url(#paint12_linear_374_93997)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.761 57.9424H34.4059L29.7773 63.8934L31.761 57.9424Z",
    fill: "url(#paint13_linear_374_93997)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_374_93997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 57.9422L29.777 51.9912L27.7933 57.9422H25.1484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 51.9912L31.7607 57.9422H34.4056L29.777 51.9912Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 57.9422L29.777 51.9912L31.7607 57.9422H27.7933Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 63.8933L25.1484 57.9422H27.7933L29.777 63.8933Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 57.9422H34.4056L29.777 63.8933L31.7607 57.9422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 57.9422H27.7933L29.777 63.8933L31.7607 57.9422Z",
    fill: "white",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_93997)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_374_93997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 51,
    width: 10,
    height: 13
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 57.9422L29.777 51.9912L27.7933 57.9422H25.1484Z",
    fill: "url(#paint14_linear_374_93997)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 51.9912L31.7607 57.9422H34.4056L29.777 51.9912Z",
    fill: "url(#paint15_linear_374_93997)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 57.9422L29.777 51.9912L31.7607 57.9422H27.7933Z",
    fill: "url(#paint16_linear_374_93997)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 63.8933L25.1484 57.9422H27.7933L29.777 63.8933Z",
    fill: "url(#paint17_linear_374_93997)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 57.9422H34.4056L29.777 63.8933L31.7607 57.9422Z",
    fill: "url(#paint18_linear_374_93997)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 57.9422H27.7933L29.777 63.8933L31.7607 57.9422Z",
    fill: "url(#paint19_linear_374_93997)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_374_93997)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_374_93997)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7909 51.9956L27.8072 57.9466L27.7793 57.9373L29.763 51.9863L29.7909 51.9956Z",
    fill: "url(#paint20_linear_374_93997)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7637 63.8885L31.7473 57.9375L31.7752 57.9468L29.7916 63.8978L29.7637 63.8885Z",
    fill: "url(#paint21_linear_374_93997)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_374_93997)",
    filter: "url(#filter7_f_374_93997)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_374_93997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 51,
    width: 5,
    height: 7
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7483 51.9912L27.7646 57.8908H31.7834L29.7483 51.9912Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0146939
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_374_93997)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.1953,
    y: 33.1104,
    width: 0.861728,
    height: 46.9824,
    transform: "rotate(30.433 42.1953 33.1104)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 35.0039,
    width: 1.27325,
    height: 45.5408,
    transform: "rotate(30.433 42.8672 35.0039)",
    fill: "white",
    fillOpacity: 0.2
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_374_93997)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7769,
    cy: 52.4381,
    rx: 0.330612,
    ry: 0.446843,
    fill: "url(#paint22_linear_374_93997)"
  })))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0477 65.0596V63.0267H56.8137C57.3247 63.0267 57.7246 62.8767 58.0134 62.5768C58.3022 62.2769 58.4467 61.9103 58.4467 61.4771C58.4467 61.1771 58.38 60.9105 58.2467 60.6772C58.1134 60.444 57.9245 60.2607 57.6802 60.1274C57.4469 59.9941 57.1581 59.9274 56.8137 59.9274H54.0477V57.9445H56.5971C57.0303 57.9445 57.3802 57.839 57.6468 57.6279C57.9134 57.4058 58.0467 57.0725 58.0467 56.6282C58.0467 56.1949 57.9134 55.8728 57.6468 55.6617C57.3802 55.4395 57.0303 55.3285 56.5971 55.3285H54.0477V53.2956H57.097C57.8523 53.2956 58.4911 53.4344 59.0132 53.7122C59.5464 53.9899 59.9519 54.362 60.2296 54.8286C60.5073 55.2951 60.6461 55.8117 60.6461 56.3782C60.6461 57.1003 60.4129 57.7112 59.9463 58.2111C59.4797 58.711 58.791 59.0554 57.8801 59.2442L57.9468 58.3611C58.9354 58.5499 59.6964 58.9332 60.2296 59.5108C60.7739 60.0885 61.0461 60.7994 61.0461 61.6437C61.0461 62.288 60.885 62.8712 60.5628 63.3933C60.2518 63.9043 59.7963 64.3097 59.1965 64.6097C58.6077 64.9096 57.8968 65.0596 57.0636 65.0596H54.0477ZM52.0481 65.0596V53.2956H54.6309V65.0596H52.0481ZM62.4895 65.0596V56.9614H65.0389V65.0596H62.4895ZM65.0389 60.6106L63.9725 59.7774C64.1835 58.8332 64.539 58.1001 65.0389 57.5779C65.5388 57.0558 66.2331 56.7948 67.1218 56.7948C67.5106 56.7948 67.8494 56.8559 68.1382 56.9781C68.4381 57.0892 68.6992 57.2669 68.9213 57.5113L67.405 59.4275C67.2939 59.3053 67.1551 59.2109 66.9884 59.1443C66.8218 59.0776 66.633 59.0443 66.4219 59.0443C65.9998 59.0443 65.661 59.1776 65.4055 59.4442C65.1611 59.6997 65.0389 60.0885 65.0389 60.6106ZM73.2718 65.2429C72.4386 65.2429 71.6833 65.0596 71.0056 64.693C70.3391 64.3153 69.8115 63.8043 69.4227 63.16C69.0339 62.5157 68.8395 61.7937 68.8395 60.9938C68.8395 60.194 69.0339 59.4775 69.4227 58.8443C69.8115 58.2111 70.3391 57.7113 71.0056 57.3447C71.6721 56.967 72.4275 56.7781 73.2718 56.7781C74.116 56.7781 74.8714 56.9614 75.5379 57.328C76.2044 57.6946 76.7321 58.2 77.1209 58.8443C77.5097 59.4775 77.7041 60.194 77.7041 60.9938C77.7041 61.7937 77.5097 62.5157 77.1209 63.16C76.7321 63.8043 76.2044 64.3153 75.5379 64.693C74.8714 65.0596 74.116 65.2429 73.2718 65.2429ZM73.2718 62.9267C73.6384 62.9267 73.9605 62.849 74.2382 62.6934C74.5159 62.5268 74.727 62.2991 74.8714 62.0103C75.0269 61.7103 75.1047 61.3715 75.1047 60.9938C75.1047 60.6161 75.0269 60.2884 74.8714 60.0107C74.7159 59.7219 74.4993 59.4997 74.2216 59.3442C73.955 59.1776 73.6384 59.0943 73.2718 59.0943C72.9163 59.0943 72.5997 59.1776 72.322 59.3442C72.0443 59.4997 71.8277 59.7219 71.6721 60.0107C71.5166 60.2995 71.4389 60.6328 71.4389 61.0105C71.4389 61.3771 71.5166 61.7103 71.6721 62.0103C71.8277 62.2991 72.0443 62.5268 72.322 62.6934C72.5997 62.849 72.9163 62.9267 73.2718 62.9267ZM84.3221 65.0596V60.444C84.3221 60.0218 84.1888 59.683 83.9222 59.4275C83.6667 59.1609 83.339 59.0276 82.9391 59.0276C82.6614 59.0276 82.417 59.0887 82.2059 59.2109C81.9949 59.322 81.8282 59.4886 81.706 59.7108C81.5839 59.9219 81.5228 60.1662 81.5228 60.444L80.5396 59.9607C80.5396 59.3275 80.6785 58.7721 80.9562 58.2945C81.2339 57.8168 81.6172 57.4502 82.106 57.1947C82.6058 56.9281 83.1668 56.7948 83.7889 56.7948C84.3888 56.7948 84.9164 56.9392 85.3719 57.228C85.8384 57.5057 86.205 57.8779 86.4716 58.3444C86.7382 58.811 86.8715 59.322 86.8715 59.8774V65.0596H84.3221ZM78.9733 65.0596V56.9614H81.5228V65.0596H78.9733ZM87.9924 63.5599L92.0581 58.4444H95.1574L91.0917 63.5599H87.9924ZM87.9924 65.0596V63.5599L89.8086 62.9267H95.0574V65.0596H87.9924ZM88.2923 59.0943V56.9614H95.1574V58.4444L93.3578 59.0943H88.2923ZM100.351 65.2429C99.4737 65.2429 98.6905 65.0651 98.0018 64.7097C97.3242 64.3431 96.791 63.8376 96.4022 63.1933C96.0134 62.549 95.819 61.8214 95.819 61.0105C95.819 60.1996 96.0078 59.4775 96.3855 58.8443C96.7743 58.2 97.2964 57.6946 97.9518 57.328C98.6072 56.9614 99.3459 56.7781 100.168 56.7781C100.968 56.7781 101.673 56.9503 102.284 57.2947C102.895 57.639 103.373 58.1167 103.717 58.7277C104.073 59.3387 104.25 60.0385 104.25 60.8272C104.25 60.9716 104.239 61.1271 104.217 61.2938C104.206 61.4493 104.178 61.6326 104.134 61.8436L97.152 61.8603V60.1107L103.051 60.094L101.951 60.8272C101.94 60.3606 101.868 59.9774 101.734 59.6775C101.601 59.3664 101.401 59.1331 101.134 58.9776C100.879 58.811 100.562 58.7277 100.185 58.7277C99.7847 58.7277 99.4348 58.8221 99.1349 59.011C98.8461 59.1887 98.6183 59.4442 98.4517 59.7774C98.2962 60.1107 98.2184 60.5162 98.2184 60.9938C98.2184 61.4715 98.3017 61.8825 98.4684 62.2269C98.6461 62.5601 98.8905 62.8212 99.2015 63.01C99.5237 63.1878 99.9014 63.2766 100.335 63.2766C100.735 63.2766 101.096 63.21 101.418 63.0767C101.74 62.9323 102.023 62.7212 102.267 62.4435L103.667 63.8432C103.267 64.3097 102.784 64.6597 102.218 64.8929C101.651 65.1262 101.029 65.2429 100.351 65.2429ZM108.887 65.0596V53.2956H110.754L115.386 60.5106H114.436L119.052 53.2956H120.935V65.0596H118.319V57.7113L118.785 57.8279L115.769 62.5268H114.036L111.037 57.8279L111.487 57.7113V65.0596H108.887ZM126.957 65.2429C126.079 65.2429 125.296 65.0651 124.607 64.7097C123.929 64.3431 123.396 63.8376 123.007 63.1933C122.619 62.549 122.424 61.8214 122.424 61.0105C122.424 60.1996 122.613 59.4775 122.991 58.8443C123.38 58.2 123.902 57.6946 124.557 57.328C125.212 56.9614 125.951 56.7781 126.773 56.7781C127.573 56.7781 128.278 56.9503 128.889 57.2947C129.5 57.639 129.978 58.1167 130.322 58.7277C130.678 59.3387 130.856 60.0385 130.856 60.8272C130.856 60.9716 130.845 61.1271 130.822 61.2938C130.811 61.4493 130.783 61.6326 130.739 61.8436L123.757 61.8603V60.1107L129.656 60.094L128.556 60.8272C128.545 60.3606 128.473 59.9774 128.34 59.6775C128.206 59.3664 128.006 59.1331 127.74 58.9776C127.484 58.811 127.168 58.7277 126.79 58.7277C126.39 58.7277 126.04 58.8221 125.74 59.011C125.451 59.1887 125.224 59.4442 125.057 59.7774C124.901 60.1107 124.824 60.5162 124.824 60.9938C124.824 61.4715 124.907 61.8825 125.074 62.2269C125.251 62.5601 125.496 62.8212 125.807 63.01C126.129 63.1878 126.507 63.2766 126.94 63.2766C127.34 63.2766 127.701 63.21 128.023 63.0767C128.345 62.9323 128.628 62.7212 128.873 62.4435L130.272 63.8432C129.873 64.3097 129.389 64.6597 128.823 64.8929C128.256 65.1262 127.634 65.2429 126.957 65.2429ZM132.086 65.0596V56.9614H134.636V65.0596H132.086ZM137.268 65.0596V60.3273C137.268 59.9163 137.141 59.5997 136.885 59.3775C136.641 59.1443 136.335 59.0276 135.969 59.0276C135.713 59.0276 135.485 59.0832 135.285 59.1942C135.086 59.2942 134.924 59.4386 134.802 59.6275C134.691 59.8163 134.636 60.0496 134.636 60.3273L133.653 59.8941C133.653 59.2498 133.791 58.6999 134.069 58.2445C134.347 57.7779 134.724 57.4224 135.202 57.178C135.68 56.9225 136.219 56.7948 136.818 56.7948C137.385 56.7948 137.89 56.9225 138.335 57.178C138.79 57.4335 139.151 57.789 139.418 58.2445C139.684 58.6999 139.818 59.2442 139.818 59.8774V65.0596H137.268ZM142.45 65.0596V60.3273C142.45 59.9163 142.323 59.5997 142.067 59.3775C141.823 59.1443 141.517 59.0276 141.151 59.0276C140.895 59.0276 140.668 59.0832 140.468 59.1942C140.268 59.2942 140.107 59.4386 139.984 59.6275C139.873 59.8163 139.818 60.0496 139.818 60.3273L138.351 60.1274C138.374 59.4386 138.535 58.8499 138.835 58.3611C139.146 57.8612 139.551 57.478 140.051 57.2114C140.562 56.9337 141.134 56.7948 141.767 56.7948C142.389 56.7948 142.939 56.9281 143.417 57.1947C143.906 57.4502 144.289 57.8223 144.567 58.3111C144.855 58.7888 145 59.3664 145 60.044V65.0596H142.45ZM151.299 65.2262C150.755 65.2262 150.255 65.1151 149.8 64.8929C149.344 64.6597 148.972 64.3542 148.683 63.9765C148.394 63.5877 148.228 63.1545 148.183 62.6768V59.2609C148.228 58.7832 148.394 58.3611 148.683 57.9945C148.972 57.6168 149.344 57.3224 149.8 57.1114C150.255 56.9003 150.755 56.7948 151.299 56.7948C152.066 56.7948 152.743 56.9781 153.332 57.3447C153.932 57.7113 154.399 58.2111 154.732 58.8443C155.076 59.4775 155.248 60.1996 155.248 61.0105C155.248 61.8214 155.076 62.5435 154.732 63.1767C154.399 63.8099 153.932 64.3097 153.332 64.6763C152.743 65.0429 152.066 65.2262 151.299 65.2262ZM150.849 62.9267C151.205 62.9267 151.516 62.8434 151.782 62.6768C152.06 62.5102 152.277 62.2824 152.432 61.9936C152.588 61.7048 152.666 61.3771 152.666 61.0105C152.666 60.6328 152.588 60.2995 152.432 60.0107C152.277 59.7219 152.06 59.4997 151.782 59.3442C151.516 59.1776 151.205 59.0943 150.849 59.0943C150.494 59.0943 150.177 59.1776 149.9 59.3442C149.622 59.4997 149.405 59.7219 149.25 60.0107C149.105 60.2995 149.033 60.6328 149.033 61.0105C149.033 61.3882 149.111 61.7214 149.266 62.0103C149.422 62.2991 149.633 62.5268 149.9 62.6934C150.177 62.849 150.494 62.9267 150.849 62.9267ZM146.634 65.0596V52.9623H149.183V58.9443L148.766 60.9105L149.15 62.8767V65.0596H146.634ZM160.543 65.2429C159.665 65.2429 158.882 65.0651 158.193 64.7097C157.515 64.3431 156.982 63.8376 156.593 63.1933C156.205 62.549 156.01 61.8214 156.01 61.0105C156.01 60.1996 156.199 59.4775 156.577 58.8443C156.966 58.2 157.488 57.6946 158.143 57.328C158.799 56.9614 159.537 56.7781 160.359 56.7781C161.159 56.7781 161.864 56.9503 162.475 57.2947C163.086 57.639 163.564 58.1167 163.908 58.7277C164.264 59.3387 164.442 60.0385 164.442 60.8272C164.442 60.9716 164.431 61.1271 164.408 61.2938C164.397 61.4493 164.369 61.6326 164.325 61.8436L157.343 61.8603V60.1107L163.242 60.094L162.142 60.8272C162.131 60.3606 162.059 59.9774 161.926 59.6775C161.792 59.3664 161.592 59.1331 161.326 58.9776C161.07 58.811 160.754 58.7277 160.376 58.7277C159.976 58.7277 159.626 58.8221 159.326 59.011C159.037 59.1887 158.81 59.4442 158.643 59.7774C158.487 60.1107 158.41 60.5162 158.41 60.9938C158.41 61.4715 158.493 61.8825 158.66 62.2269C158.837 62.5601 159.082 62.8212 159.393 63.01C159.715 63.1878 160.093 63.2766 160.526 63.2766C160.926 63.2766 161.287 63.21 161.609 63.0767C161.931 62.9323 162.214 62.7212 162.459 62.4435L163.858 63.8432C163.459 64.3097 162.975 64.6597 162.409 64.8929C161.842 65.1262 161.22 65.2429 160.543 65.2429ZM165.672 65.0596V56.9614H168.222V65.0596H165.672ZM168.222 60.6106L167.155 59.7774C167.366 58.8332 167.722 58.1001 168.222 57.5779C168.722 57.0558 169.416 56.7948 170.305 56.7948C170.693 56.7948 171.032 56.8559 171.321 56.9781C171.621 57.0892 171.882 57.2669 172.104 57.5113L170.588 59.4275C170.477 59.3053 170.338 59.2109 170.171 59.1443C170.005 59.0776 169.816 59.0443 169.605 59.0443C169.183 59.0443 168.844 59.1776 168.588 59.4442C168.344 59.6997 168.222 60.0885 168.222 60.6106Z",
    fill: "#835602"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_374_93997",
    x: 274.534,
    y: 33.9904,
    width: 23.8025,
    height: 15.5759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925714,
    result: "effect1_foregroundBlur_374_93997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_374_93997",
    x: 261.692,
    y: 39.8903,
    width: 33.8629,
    height: 53.6393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.62857,
    result: "effect1_foregroundBlur_374_93997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_374_93997",
    x: 206.524,
    y: -23.6695,
    width: 175.527,
    height: 90.4191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43584,
    result: "effect1_foregroundBlur_374_93997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddddd_374_93997",
    x: -51.8396,
    y: 22.9197,
    width: 163.851,
    height: 163.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973442
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.037943 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.33932
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0479222 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_93997",
    result: "effect2_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40472
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0544001 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_93997",
    result: "effect3_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.85728
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0602938 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_93997",
    result: "effect4_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6962
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0681504 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_93997",
    result: "effect5_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.1771
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_93997",
    result: "effect6_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_93997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddddd_374_93997",
    x: -11.8801,
    y: 51.9912,
    width: 83.6226,
    height: 95.8338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.512338
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.0787208 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23122
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.11309 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_93997",
    result: "effect2_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.31828
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_93997",
    result: "effect3_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13541
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.16691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_93997",
    result: "effect4_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.73483
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.201279 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_93997",
    result: "effect5_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_93997",
    result: "effect6_dropShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_93997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_374_93997",
    x: 25.1484,
    y: 51.8737,
    width: 9.25684,
    height: 12.1521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.132245
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117551
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_374_93997"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.117551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_374_93997",
    result: "effect2_innerShadow_374_93997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_374_93997",
    x: 27.1915,
    y: 51.3986,
    width: 3.18723,
    height: 7.13547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.293878
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_374_93997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_374_93997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_374_93997",
    x: 27.412,
    y: 51.6386,
    width: 4.72386,
    height: 6.60472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.176327,
    result: "effect1_foregroundBlur_374_93997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_374_93997",
    x: 28.7851,
    y: 51.33,
    width: 1.98358,
    height: 2.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.330612,
    result: "effect1_foregroundBlur_374_93997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_93997",
    x1: 3.0375,
    y1: 6.22322,
    x2: 299.479,
    y2: 197.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAC294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475341,
    stopColor: "#F0DEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC9B5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_374_93997",
    x1: 239.76,
    y1: 153.337,
    x2: 44.0917,
    y2: 8.73938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE56",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFEF",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_374_93997",
    x1: 261.219,
    y1: 12.6958,
    x2: 340.343,
    y2: 122.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91681A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_374_93997",
    x1: 359.177,
    y1: 89.3316,
    x2: 264.798,
    y2: 166.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0923C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#9A6D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#99690D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A7328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_374_93997",
    x1: 248.729,
    y1: -1.18152,
    x2: 324.832,
    y2: 104.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1C182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_374_93997",
    x1: 318.477,
    y1: -21.6434,
    x2: 263.751,
    y2: 124.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFA860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417119,
    stopColor: "#8C6D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C99534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_374_93997",
    x1: 250.405,
    y1: 23.1425,
    x2: 317.6,
    y2: 87.8967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6A0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopColor: "#E9C685",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_374_93997",
    x1: 26.318,
    y1: 80.1044,
    x2: 30.068,
    y2: 58.5419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#754E04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_374_93997",
    x1: 29.777,
    y1: 51.9912,
    x2: 25.3616,
    y2: 58.0964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#CFB49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72492F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_374_93997",
    x1: 31.7613,
    y1: 51.9912,
    x2: 27.1784,
    y2: 57.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#CFB49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72492F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_374_93997",
    x1: 34.4059,
    y1: 51.9912,
    x2: 29.9905,
    y2: 58.0964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#CFB49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72492F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_374_93997",
    x1: 29.777,
    y1: 57.9424,
    x2: 25.3616,
    y2: 64.0476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#CFB49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72492F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_374_93997",
    x1: 31.7613,
    y1: 57.9424,
    x2: 27.1784,
    y2: 63.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#CFB49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72492F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_374_93997",
    x1: 34.4059,
    y1: 57.9424,
    x2: 29.9905,
    y2: 64.0476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#CFB49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72492F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_374_93997",
    x1: 34.4056,
    y1: 51.9912,
    x2: 22.3105,
    y2: 56.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_374_93997",
    x1: 25.1484,
    y1: 51.9912,
    x2: 37.2436,
    y2: 56.8972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_374_93997",
    x1: 29.777,
    y1: 51.9912,
    x2: 29.777,
    y2: 63.8933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_374_93997",
    x1: 25.1484,
    y1: 51.9912,
    x2: 33.9792,
    y2: 64.2016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_374_93997",
    x1: 34.4056,
    y1: 51.9912,
    x2: 25.5748,
    y2: 64.2016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_374_93997",
    x1: 29.777,
    y1: 57.9422,
    x2: 29.0351,
    y2: 63.7993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_374_93997",
    x1: 29.7769,
    y1: 51.991,
    x2: 27.7932,
    y2: 57.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_374_93997",
    x1: 31.7752,
    y1: 57.9375,
    x2: 27.6666,
    y2: 60.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#CFB49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72492F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_374_93997",
    x1: 29.7769,
    y1: 51.9912,
    x2: 29.7769,
    y2: 52.8849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_93997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 324,
    height: 170,
    rx: 12.0343,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_93997"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 46.9883,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_93997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.25714,
    height: 11.902,
    fill: "white",
    transform: "translate(25.1484 51.9912)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_374_93997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.01878,
    height: 5.89959,
    fill: "white",
    transform: "translate(27.7646 51.9912)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberBronze);
export default __webpack_public_path__ + "static/media/member_bronze.c645def097ad41a4ecc7c776624e9dbc.svg";
export { ForwardRef as ReactComponent };